"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var RateLimitingService = (function () {
    function RateLimitingService() {
    }
    RateLimitingService.limitOptions = function (options, timezone) {
        var _this = this;
        var current = (0, moment_timezone_1.default)().isoWeekday();
        return options
            .filter(function (option) { return option.days.includes(current); })
            .filter(function (option) {
            var now = Date.now();
            var start = _this.intervalWithTimezone(option.start, timezone);
            var end = _this.intervalWithTimezone(option.end, timezone);
            return now > start && now < end;
        });
    };
    RateLimitingService.getCurrentRateLimit = function (options) {
        if (!options.length)
            return null;
        if (options.length === 1)
            return options[0].limit;
        return options.sort(function (prev, curr) { return prev.limit - curr.limit; })[0].limit;
    };
    RateLimitingService.convertWeekDays = function (days) {
        var weekdays = [];
        Object.entries(days).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], val = _b[1];
            if (val) {
                switch (key) {
                    case "monday":
                        weekdays.push(1);
                        break;
                    case "tuesday":
                        weekdays.push(2);
                        break;
                    case "wednesday":
                        weekdays.push(3);
                        break;
                    case "thursday":
                        weekdays.push(4);
                        break;
                    case "friday":
                        weekdays.push(5);
                        break;
                    case "saturday":
                        weekdays.push(6);
                        break;
                    case "sunday":
                        weekdays.push(7);
                        break;
                }
            }
            return null;
        });
        return weekdays;
    };
    RateLimitingService.intervalWithTimezone = function (interval, timezone) {
        return moment_timezone_1.default.tz(interval, "HH:mm:ss", timezone).toDate().getTime();
    };
    return RateLimitingService;
}());
exports.default = RateLimitingService;
//# sourceMappingURL=index.js.map